// const cookie = require('cookie_js').cookie;

const JSON = window.JSON;
const support = supportLocalStorage();
function supportLocalStorage() {
  try {
    if (window.localStorage) {
      try {
        window.localStorage.setItem('test', 1);
        window.localStorage.removeItem('test');
        return true;
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  } catch (error) {

  }


}

class Storage {
  getItem(key) {
    let value = null;
    if (support) {
      value = window.localStorage.getItem(key);
    }
    return value;
  }

  setItem(key, value) {
    if (!value) {
      return;
    }
    if (support) {
      window.localStorage.setItem(key, value);
      return;
    }
    // cookie.set(key, value);
  }

  setItemToCookie(key, value) {
    if (!value) {
      return;
    }
    if (support) {
      window.localStorage.setItem(key, value);
    }
  }

  setObj(key, obj) {
    if (!obj) {
      return;
    }
    if (support) {
      window.localStorage.setItem(key, JSON.stringify(obj));
      return;
    }
  }

  setObjToCookie(key, obj) {
    if (!obj) {
      return;
    }
    if (support) {
      window.localStorage.setItem(key, obj);
    }
  }

  getObj(key) {
    let value = null;
    if (support) {
      if (localStorage.getItem(key)) {
        value = JSON.parse(localStorage.getItem(key));
      }
    }
    return value;
  }

  clearLocalStorage() {
    if (support) {
      window.localStorage.clear();
    }
  }

  clearCookie() {
    // cookie.empty();
  }

  clear() {
    if (support) {
      window.localStorage.clear();
    }
    // cookie.empty();
  }

  removeItem(key) {
    if (support) {
      window.localStorage.removeItem(key);
    }
    // cookie.remove(key);
  }
};

window.LS = new Storage();



// WEBPACK FOOTER //
// ./src/core/storage.js